
export function isErrorType (aggStatusString) {
  const acceptable = ['NEW', 'OK', 'MFA_CHALLENGE_READY_FOR_USER', 'AGGREGATOR_STATUS_DISCOVERED_ACCOUNTS_READY_FOR_USER', 'AGGREGATOR_STATUS_NO_ACCOUNTS_REFRESHED'];
  return !acceptable.includes(aggStatusString);
}